let simplButton = document.querySelector(".custom-simpl-button");

let updateNotesApi = async (data) => {
  try {
    let from = data.From ? data.From : "";
    let to = data.To ? data.To : "";
    let message = data.Message ? data.Message : "";
    await fetch("/cart", {
      headers: {
        accept:
          "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7",
        "content-type": "application/x-www-form-urlencoded",
      },
      body: `updates%5B%5D=1&attributes%5Bgift-wrapping%5D=&attributes%5Bcart-notes%5D=on&attributes%5BFrom%5D=${from}&attributes%5BTo%5D=${to}&attributes%5BMessage%5D=${message}&checkout=`,
      method: "POST",
    });
  } catch (e) {
    console.log(e);
  }
};

let textChangable = () => {
  const fromInput = document.getElementById("from")?.value;
  const toInput = document.getElementById("to")?.value;
  const messageInput = document.getElementById("gift-card")?.value;
  const jsonObject = {
    From: fromInput,
    To: toInput,
    Message: messageInput,
    "cart-notes": "on",
  };
  return jsonObject;
};

let inputTextHolder = () => {
  let inputTypeText = document.querySelectorAll("input[type='text']");
  console.log("input identifer", inputTypeText);
  inputTypeText.forEach((element) => {
    element.addEventListener("change", (e) => {
      updateNotesApi(textChangable());
    });
  });
};

let cartNotesClick = document.querySelector("#cart-notes");
cartNotesClick.addEventListener("change", () => {
  if (cartNotesClick.checked) {
    inputTextHolder();
  } else {
    console.log("unchecked");
  }
});
if(simplButton){
simplButton.addEventListener("click", async (event) => {
  event.preventDefault();
  try {
    let data = textChangable();
    const res = await fetch("/cart.json");
    const response = await res.json();
    const payload = {
      data: {
        cart: response,
        attributes: data,
      },
      type: "cart",
    };
    console.log("simplPayload", payload);
    window?.initSimplCheckout(payload);
  } catch (e) {
    console.log("Error for Simpl---->", e);
    window?.initSimplCheckout({ error: "something went wrong" });
  }
});
}

inputTextHolder();

let buttonCss = `width: 100%;height: 55px;margin-bottom: 13px; border-radius: 12px;color: white; background: #0289FD !important;   font-size: 19px;`;
if(simplButton){
simplButton.setAttribute("style", buttonCss);
}
